// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDTaK9IBmJ15GggIrAs3dJ54ecd6cKSZrM",
  authDomain: "ezinterview-f7f5e.firebaseapp.com",
  projectId: "ezinterview-f7f5e",
  storageBucket: "ezinterview-f7f5e.appspot.com",
  messagingSenderId: "949247855969",
  appId: "1:949247855969:web:b4128d9eeb85c932ab4920"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);